export default "__VITE_ASSET__5$m137oi__"